module.exports = __webpack_public_path__ + "static/media/louge_lightent.40f392c9.png";